// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function() {
    var textarea_maxlength = function(el) {
        var maxlength = el.attr('maxlength');
        if (maxlength && (maxlength > 0)) {
            // chrome reports maxlength of -1 if attribute missing
            el.keydown(function() {
                if (el.val().length > maxlength) {
                    el.val(el.val().substring(0, maxlength));
                }
            });
        }
    };

    $a.each_current_and_future('textarea', textarea_maxlength);
})();
